export default __webpack_public_path__ + "static/accroche-video-bg-85ddacadb37a02d0eb1889d7aec2f699.mp4";